import { login } from '@/api/login';
import { getShipperAuth } from '@/api/public';
import { bankInformation } from '@/api/payManage';
import { setToken, removeToken } from '@/utils/auth';
import { setConfig, getConfig } from "@/utils/auth";
import { getGlobalConfig } from '@/api/public';
import { Message } from 'element-ui';
import router from '@/router';
const state = {
  resetMain: true,//用于重置右侧中心页面
  userId: '',//用户id
  userInfo: '',//用户登录信息
  authInfo: '',//用户认证信息
  globalConfig: "",//全局配置
  avatar: '',
  accountBalanceInfo: {
    money: 0
  },//用户支付完回显的余额信息
};
const mutations = {
  SET_RESET_MAIN: (state, resetMain) => {
    state.resetMain = resetMain
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
    localStorage.setItem('userId', JSON.stringify(userId));

  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  SET_AUTHINFO: (state, authInfo) => {
    state.authInfo = authInfo;
    localStorage.setItem('authInfo', JSON.stringify(authInfo));
  },
  SET_ACCOUNT_BALANCE_INFO: (state, accountBalanceInfo) => {
    state.accountBalanceInfo = accountBalanceInfo;
  },
  SET_GLOBAL_CONFIG: (state, globalConfig) => {
    state.globalConfig = globalConfig;
    setConfig(globalConfig);
  },
};
const actions = {
  // 登录
  Login({ commit, dispatch }, userInfo) {
    const phone = userInfo.phone;
    const password = userInfo.password;
    const level = userInfo.level;
    return new Promise((resolve, reject) => {
      login({
        phone,
        password,
        level
      }).then(async res => {
        if (res.code == 200) {
          setToken(res.data.token)
          commit('SET_USERID', res.data.user_id);
          resolve({
            code: 200,
            msg: res.msg
          })
        }
        // else {
        //   Message({ message: res.msg, type: 'error' })
        // }

      }).catch(error => {
        reject(error)
      })
    })
  },
  setGlobalConfig({ commit }) {
    return new Promise((resolve, reject) => {
      if (getConfig()) {
        //存在全局数据 不重复请求
        resolve({ code: 200 })
      } else {
        getGlobalConfig().then(res => {
          if (res.code == 200) {
            commit('SET_GLOBAL_CONFIG', res.data)
            resolve({ code: 200 });
          } else {
            resolve({ code: 0 });
          }
        }).catch(error => {
          resolve(error)
        })
      }

    })
  },
  setResetMain({ commit }, state) {
    return new Promise((resolve, reject) => {
      commit('SET_RESET_MAIN', state);
      resolve();
    })
  },
  setUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getShipperAuth().then(res => {
        if (res.code == 200) {
          commit('SET_AUTHINFO', res.data.auth);
          commit('SET_USERINFO', res.data.info);
          commit('SET_AVATAR', res.data.info.head_pic);
          resolve(res.data)
        }
      }).catch(error => {
        reject(error)
      })

    })
  },
  // 退出系统
  LogOut({ commit, state }) {
    return new Promise((resolve, reject) => {
      //清除所有本地存储
      commit('SET_AUTHINFO', '');
      commit('SET_USERINFO', '');
      commit('SET_AVATAR', '');
      localStorage.clear();
      router.push("/login");
      resolve()
    })
  },
  setAccountBalance({ commit, state }) {
    return new Promise((resolve, reject) => {
      bankInformation().then(res => {
        if (res.code == 200) {
          commit('SET_ACCOUNT_BALANCE_INFO', res.data);
          resolve({ code: 200 });
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

